// extracted by mini-css-extract-plugin
module.exports = {"downloadLinksCell":"tableRow_downloadLinksCell__P2giN","dateCell":"tableRow_dateCell__CNAqm","row":"tableRow_row__oWrX4"};